import "./App.css";

import * as React from "react";
import Index from "./components/Index";
import News from "./components/News";
import Contact from "./components/Contact";
import Music from "./components/Music";
import Menu from "./components/Menu";
import LivingRoom from "./components/LivingRoom";
import GuestBook from "./components/GuestBook";
import AboutUs from "./components/AboutUs";
import Imprint from "./components/Imprint";

export type TView =
    "index" |
    "contact" |
    "news" |
    "music" |
    "about_us" |
    "living-room" |
    "guest-book" |
    "about-us" |
    "imprint";

interface IAppProps {}

interface IAppState {
    currentView: TView;
}

export default class App extends React.Component<IAppProps, IAppState> {

    public constructor(props: IAppProps) {
        super(props);

        this.state = {
            currentView: this.viewFromQuery || "index"
        };
    }

    public render() {

        if (this.state.currentView === "index") {
            return (
                <div
                    className="App"
                    onClick={() => {
                        this.handleChangeOfCurrentView("news");
                    }}
                >
                    <Index/>
                </div>
            );
        }

        let content;

        switch (this.state.currentView) {
            case "contact":
                content = <Contact/>;
                break;
            case "music":
                content = <Music/>;
                break;
            case "living-room":
                content = <LivingRoom changeHandler={this.handleChangeOfCurrentView}/>;
                break;
            case "guest-book":
                content = <GuestBook/>;
                break;
            case "about-us":
                content = <AboutUs/>;
                break;
            case "imprint":
                content = <Imprint/>;
                break;
            case "news":
            default:
                content = <News/>;
        }

        return (
            <div className="App">
                <Menu
                    currentView={this.state.currentView}
                    changeHandler={this.handleChangeOfCurrentView}
                />
                <div className="App__content">
                    {content}
                </div>

                {this.state.currentView !== "imprint" && this.renderFooter()}
            </div>
        );
    }

    private handleChangeOfCurrentView = (view: TView) => {
        this.setState({
            currentView: view
        });

        let viewInUrl = "";
        if (view === "news") {
            viewInUrl = "aktuelles";
        } else if (view === "music") {
            viewInUrl = "musik";
        } else if (view === "contact") {
            viewInUrl = "kontakt";
        } else if (view === "living-room") {
            viewInUrl = "wohnzimmer";
        } else if (view === "guest-book") {
            viewInUrl = "gaestebuch";
        } else if (view === "about-us") {
            viewInUrl = "ueberuns";
        } else if (view === "imprint") {
            viewInUrl = "impressum";
        }

        if (viewInUrl) {
            window.history.pushState({}, "", `?${viewInUrl}`);
        } else {
            window.history.pushState({}, "", "?");
        }
    }

    private get viewFromQuery(): TView {
        let query = window.location.search.replace("?", ""); // tslint:disable-line:no-any

        if (query === "aktuelles") {
            return "news";
        } else if (query === "musik") {
            return "music";
        } else if (query === "kontakt") {
            return "contact";
        } else if (query === "wohnzimmer") {
            return "living-room";
        } else if (query === "gaestebuch") {
            return "guest-book";
        } else if (query === "ueberuns") {
            return "about-us";
        } else if (query === "impressum") {
            return "imprint";
        }

        return "index";
    }

    private get isDev() {
        return !!window.location.href.match(/localhost/);
    }

    private renderFooter() {

        return (
            <div className="App__footer">
                <div onClick={() => this.handleChangeOfCurrentView("imprint")}>Impressum</div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/App.tsx